var $j = jQuery.noConflict();

window.growl_message = function (message) {
    if( message !== null) {
        $j.jGrowl( message,
            {
                'life' : 3000,
                'closer' : false,
                'closeTemplate' : '',
                'position' : 'top-right-custom',
                'theme' : 'growl-modal'
            }
        );
    }
}